import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { LanguageSelectorComponent } from '../components/language-selector.component';
import { FooterComponent } from '../components/footer.component';
import { RightPanelComponent } from '../components/right-panel.component';
import { CookieBannerComponent } from '../components/cookie-banner/cookie-banner.component';
import { ToastComponent } from '../components/toast/toast.component';
import { LanguageService } from '../services/language.service';
import { UiStateService } from '../services/ui-state.service';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [RouterOutlet, TranslocoModule, LanguageSelectorComponent, FooterComponent, RightPanelComponent, CookieBannerComponent, ToastComponent],
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent {
  private readonly languageService = inject(LanguageService);
  readonly uiState = inject(UiStateService);

  get currentLang(): string {
    return this.languageService.getCurrentLanguage();
  }

  switchLanguage(lang: string): void {
    this.languageService.setLanguage(lang);
  }
}
